module.exports = __webpack_public_path__ + "static/img/79-3.8f67024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/79-3.jpg
// module id = rVeE
// module chunks = 0